import { TextField } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { ButtonWithLoader } from 'components/reusable/button-loader';
import { setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { changeUserInfo, resendVerification } from 'store/sagas/sagas';
import './profile.css';
export const UserInfo = () => {
    const { state, asyncDispatch, dispatch } = useGlobalState();
    const [isLoading, setIsLoading] = useState(false);
    const [verify, setVerify] = useState(true);
    const user = {
        ...state.user
    };
    const [firstName, setFirstName] = useState(user.firstName);
    const handleChangeFirstName = useCallback((e) => {
        setFirstName(e.target.value);
    }, []);
    const [lastName, setLastName] = useState(user.lastName);
    const handleChangeLastName = useCallback((e) => {
        setLastName(e.target.value);
    }, []);
    const submitIsDisabled = firstName.length === 0 ||
        lastName.length === 0 ||
        (firstName === user.firstName && lastName === user.lastName);
    const onSubmitName = (event) => {
        event.preventDefault();
        setIsLoading(true);
        asyncDispatch(changeUserInfo({
            firstName,
            lastName
        }))
            .then(() => {
            setIsLoading(false);
            dispatch(setMessages({
                value: 'Name changed successfully',
                severity: 'success'
            }));
        })
            .catch(() => {
            setIsLoading(false);
        });
    };
    const handleVerifyEmail = () => {
        if (state.user?.email) {
            asyncDispatch(resendVerification(state.user.email))
                .then(() => {
                setVerify(false);
            })
                .catch(console.error);
        }
    };
    return (React.createElement(React.Fragment, null,
        !user.emailVerified && verify && (React.createElement("div", { className: "g-form" },
            React.createElement(ButtonWithLoader, { disabled: false, isLoading: false, name: "Resend Verification Email", onClick: handleVerifyEmail }))),
        React.createElement("form", { autoComplete: "off", className: "g-form", noValidate: true, onSubmit: onSubmitName },
            React.createElement("span", { className: "title" }, "Change Name"),
            React.createElement(TextField, { className: "u-margin-bottom-small", defaultValue: state.user?.firstName, disabled: !user.emailVerified, error: !firstName, label: "First Name", onChange: handleChangeFirstName, required: true }),
            React.createElement(TextField, { className: "u-margin-bottom-small", defaultValue: state.user?.lastName, disabled: !user.emailVerified, error: !lastName, label: "Last Name", onChange: handleChangeLastName, required: true }),
            React.createElement(ButtonWithLoader, { disabled: submitIsDisabled, isLoading: isLoading, name: "Update your name" }))));
};
